export default __webpack_public_path__ + "static/media/team-performance.e21f8e93.svg";